import React, { useState } from 'react';

const BRAND_BASE = `${process.env.PUBLIC_URL || ''}/assets/brand/0e3_pos`;

/**
 * Logo de marca 0E3 POS.
 */
const BrandLogo = ({
  className = 'h-8 w-auto',
  showText = true,
  variant = 'mark',
  accentClassName = ''
}) => {
  const [imgFailed, setImgFailed] = useState(false);
  const isFull = variant === 'full';
  const src = isFull
    ? `${BRAND_BASE}/logo-0e3-full.png`
    : `${BRAND_BASE}/logo-mark.svg`;

  const fallback = (
    <span className="flex flex-col justify-center leading-tight">
      <span className="text-lg font-extrabold tracking-tight text-white">0E3 POS</span>
      {showText && (
        <span className="text-[11px] font-medium uppercase tracking-[0.12em] text-[#A1A1AA]">
          Tecnología que simplifica
        </span>
      )}
    </span>
  );

  if (imgFailed) {
    return (
      <div className={`flex items-center gap-2 ${accentClassName} ${className}`.trim()}>
        {fallback}
      </div>
    );
  }

  const imgClass = isFull
    ? 'h-full w-auto max-w-full object-contain'
    : 'h-8 w-8 shrink-0 object-contain';

  return (
    <div className={`flex items-center gap-2 ${accentClassName} ${className}`.trim()}>
      <img
        src={src}
        alt={showText || isFull ? '0E3 POS' : ''}
        className={imgClass}
        aria-hidden={!showText && !isFull ? true : undefined}
        onError={() => setImgFailed(true)}
      />

      {showText && !isFull && fallback}
    </div>
  );
};

export default BrandLogo;
